<template>
  <div id="tops">
    <div class="logs">

      <div class="logsl">
        <router-link to="/"> <img src="./assets/logo.png" alt=""></router-link>

      </div>
      <div class="logsr">
        <div class="cna">
          <img src="./assets/gq.png" alt="">
          <span>中文</span>
          <div class="sanjiao"></div>
        </div>
        <div class="inps">
          <input type="text" placeholder="搜索">
        </div>
      </div>
    </div>
    <div class="uls">
      <ul>

        <li>
          <p><router-link to="/Yanjiu">研究</router-link></p>
        </li>
        <li>
          <p v-show="this.vals == 1"><router-link to="/Chanpin">产品</router-link></p>
          <p v-show="this.vals == 2"><router-link to="/Chanpin1">产品1</router-link></p>
          <p v-show="this.vals == 3"><router-link to="/Chanpin2">产品2</router-link></p>
        </li>
        <li>
          <p><router-link to="/News">企业新闻及动态</router-link></p>
        </li>
        <li>
          <p><router-link to="/Kehu">客户案例及应用</router-link></p>
        </li>
        <li>
          <p><router-link to="/Add">招贤纳士</router-link></p>
        </li>
        <li>
          <p><router-link to="/About">关于我们</router-link></p>
        </li>
        <li>
          <p><router-link to="/Call">联系我们</router-link></p>
        </li>

      </ul>
    </div>
  </div>
  <div id="centers">
    <router-view />
  </div>
  <!-- <div class="navs">
    <router-link to="/">Home</router-link>
    <router-link to="/about">ABOUT</router-link>
  </div> -->

  <div id="down" class="hovers">
    <ul>
      <li>
        <img src="./assets/logo2.png" alt="">
        <p>©iSPXtech 2023</p>
      </li>
      <li>
        <h5>公司</h5>
        <p @click="toChanp()">产品</p>
        <p @click="toAbt()">关于我们</p>
        <p @click="toAdd()">招贤纳士</p>
      </li>
      <li>
        <h5 class="nones"> 1</h5>
        <p>隐私政策</p>
        <p>Cookies</p>
        <p><a href="https://beian.miit.gov.cn" target="_blank">浙ICP备2023018720号-1</a> </p>
        <!-- <p class="nones">Cookies</p> -->
      </li>
      <li>
        <h5>关注</h5>
        <p><img class="tbs" src="./assets/tb.png" alt=""><img class="wxs" src="./assets/wx.png" alt=""></p>
        <p class="nones">Cookies</p>
        <p class="nones">Cookies</p>
      </li>
      <li>
        <h5>联系我们</h5>
        <p>杭州市钱塘区白杨街道6号大街452号2幢D1410号</p>
        <p>+86 000 000 000</p>
        <p>ispxtech@163.com</p>
      </li>
    </ul>
  </div>
</template>
<script>
// import '../public/size'
export default {
  data() {
    return {
      oks: true,
      vals: 1
    }
  },
  methods: {
    toAbt() {
      this.$router.push({ path: "/About" })
    },
    toChanp() {
      this.$router.push({ path: "/Chanpin" })
    },
    toAdd() {
      this.$router.push({ path: "/Add" })
    }

  },
  created() {
    function calcFontSize() {
      const zoom =  document.body.clientWidth / 1539;
      console.log('zoom'+zoom+"wide:"+ document.body.clientWidth)
      const size = zoom * 26;
      document.documentElement.style.fontSize = size + 'px';
      console.log('设置字体大小', size);
    }
    window.onload = () => {
      calcFontSize();
      console.log("页面加载完成")
      let resize_timer = null;
      const resize = () => {
        if (resize_timer) {
          clearTimeout(resize_timer);
        }
        resize_timer = setTimeout(() => {
          resize_timer = null;
          calcFontSize();
        }, 100);
      }
      window.onresize = resize;
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

/* ul,li{
  list-style: none;
} */
.router-link-active {
  text-decoration: #3b3c3c;
  color: #3b3c3c;
}

a:hover {
  color: #3b3c3c;
}

a {
  /* text-decoration: none; */
  color: white;
}

#tops {
  /* border: 1px solid red; */
  box-sizing: border-box;
  width: 100%;
}

#tops .logs {
  padding: 0.8rem 0;
  width: 91%;

  box-sizing: border-box;
  /* border: 1px solid red; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: auto;
}

#tops .logs .logsl {
  width: 16%;

}

#tops .logs .logsl img {
  width: 100%;
}

#tops .uls {
  background: #2180D1;

}

#tops .uls ul {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

#tops .uls ul li {
  padding: 1rem 0;
}

#tops .uls ul li p {
  font-size: 0.6rem;
  color: #F1F1F9;
  text-align: center;
}

#centers {
  /* height: 80vh; */
}




#down {
  width: 100%;

  background: #2180D1;
}

#down p {
  line-height: 2;
  font-size: 0.6rem;
  color: #F1F1F9;
}

#down ul {
  /* height: 30vh; */
  padding: 2rem 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

#down ul li:nth-child(1) {
  width: 18%;
  text-align: center;

}

#down ul li:nth-child(1) p {
  margin-top: 1rem;


}

#down ul li:nth-child(1) img {
  width: 100%;
}

#down ul li {
  /* border: 1px solid red; */
}

.tbs {
  width: 1.1rem;
}

.wxs {
  width: 1rem;
  margin-left: 0.5rem;
}

#down h5 {
  color: #F1F1F9;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  letter-spacing: 2px;
}

#down p {
  letter-spacing: 2px;
}

#down .nones {
  opacity: 0;
}

.logsr {
  /* background: pink; */
  width: 10rem;
}

.cna img {
  width: 30px;
}

.cna {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 0.4rem;
}

.inps {
  background: #eee;
  width: 100%;
  border-radius: 8rem;
  overflow: hidden;
  margin-top: 0.5rem;
}

.inps input {
  width: 100%;
  font-size: 0.6rem;
  background: #eee;
  padding: 0.2rem 2rem;
  outline: none;
  text-align: center;

}</style>
